import type { Tenant } from '@hyvay/shared-types';

export const mockTenants: Tenant[] = [
    {
        id: '1',
        userId: 'user1',
        name: 'Toko Baju Online',
        description: 'Platform e-commerce untuk menjual pakaian dan aksesoris fashion',
        icon: '👔',
        createdAt: '2024-01-10T08:00:00Z',
        updatedAt: '2024-01-15T14:30:00Z',
        status: 'PUBLISHED',
        pages: [
            {
                id: 'p1',
                applicationId: '1',
                tenantId: '1',
                name: 'Beranda',
                slug: 'home',
                components: [],
                order: 0,
                isHomePage: true,
                createdAt: '2024-01-10T08:00:00Z',
                updatedAt: '2024-01-10T08:00:00Z',
            },
            {
                id: 'p2',
                applicationId: '1',
                tenantId: '1',
                name: 'Produk',
                slug: 'products',
                components: [],
                order: 1,
                isHomePage: false,
                createdAt: '2024-01-10T08:05:00Z',
                updatedAt: '2024-01-10T08:05:00Z',
            },
            {
                id: 'p3',
                applicationId: '1',
                tenantId: '1',
                name: 'Keranjang',
                slug: 'cart',
                components: [],
                order: 2,
                isHomePage: false,
                createdAt: '2024-01-10T08:10:00Z',
                updatedAt: '2024-01-10T08:10:00Z',
            },
        ],
        settings: {
            primaryColor: '#6366f1',
            theme: 'light',
            language: 'id',
        },
    },
    {
        id: '2',
        userId: 'user1',
        name: 'Sistem Absensi Karyawan',
        description: 'Aplikasi untuk mengelola kehadiran dan absensi karyawan perusahaan',
        icon: '📋',
        createdAt: '2024-01-12T09:00:00Z',
        updatedAt: '2024-01-14T16:20:00Z',
        status: 'PUBLISHED',
        pages: [
            {
                id: 'p4',
                applicationId: '2',
                tenantId: '2',
                name: 'Dashboard',
                slug: 'dashboard',
                components: [],
                order: 0,
                isHomePage: true,
                createdAt: '2024-01-12T09:00:00Z',
                updatedAt: '2024-01-12T09:00:00Z',
            },
            {
                id: 'p5',
                applicationId: '2',
                tenantId: '2',
                name: 'Absensi',
                slug: 'attendance',
                components: [],
                order: 1,
                isHomePage: false,
                createdAt: '2024-01-12T09:05:00Z',
                updatedAt: '2024-01-12T09:05:00Z',
            },
            {
                id: 'p6',
                applicationId: '2',
                tenantId: '2',
                name: 'Laporan',
                slug: 'reports',
                components: [],
                order: 2,
                isHomePage: false,
                createdAt: '2024-01-12T09:10:00Z',
                updatedAt: '2024-01-12T09:10:00Z',
            },
        ],
        settings: {
            primaryColor: '#4f46e5',
            theme: 'light',
            language: 'id',
        },
    },
    {
        id: '3',
        userId: 'user1',
        name: 'Aplikasi Kasir Restoran',
        description: 'Sistem point of sale untuk restoran dan kafe',
        icon: '🍽️',
        createdAt: '2024-01-08T10:00:00Z',
        updatedAt: '2024-01-16T11:45:00Z',
        status: 'PUBLISHED',
        pages: [
            {
                id: 'p7',
                applicationId: '3',
                tenantId: '3',
                name: 'Menu',
                slug: 'menu',
                components: [],
                order: 0,
                isHomePage: true,
                createdAt: '2024-01-08T10:00:00Z',
                updatedAt: '2024-01-08T10:00:00Z',
            },
            {
                id: 'p8',
                applicationId: '3',
                tenantId: '3',
                name: 'Pesanan',
                slug: 'orders',
                components: [],
                order: 1,
                isHomePage: false,
                createdAt: '2024-01-08T10:05:00Z',
                updatedAt: '2024-01-08T10:05:00Z',
            },
            {
                id: 'p9',
                applicationId: '3',
                tenantId: '3',
                name: 'Pembayaran',
                slug: 'payment',
                components: [],
                order: 2,
                isHomePage: false,
                createdAt: '2024-01-08T10:10:00Z',
                updatedAt: '2024-01-08T10:10:00Z',
            },
        ],
        settings: {
            primaryColor: '#3730a3',
            theme: 'light',
            language: 'id',
        },
    },
    {
        id: '4',
        userId: 'user1',
        name: 'Portal Berita Lokal',
        description: 'Platform berita dan informasi untuk komunitas lokal',
        icon: '📰',
        createdAt: '2024-01-05T07:30:00Z',
        updatedAt: '2024-01-13T15:00:00Z',
        status: 'DRAFT',
        pages: [
            {
                id: 'p10',
                applicationId: '4',
                tenantId: '4',
                name: 'Beranda',
                slug: 'home',
                components: [],
                order: 0,
                isHomePage: true,
                createdAt: '2024-01-05T07:30:00Z',
                updatedAt: '2024-01-05T07:30:00Z',
            },
            {
                id: 'p11',
                applicationId: '4',
                tenantId: '4',
                name: 'Berita',
                slug: 'news',
                components: [],
                order: 1,
                isHomePage: false,
                createdAt: '2024-01-05T07:35:00Z',
                updatedAt: '2024-01-05T07:35:00Z',
            },
        ],
        settings: {
            primaryColor: '#4338ca',
            theme: 'light',
            language: 'id',
        },
    },
    {
        id: '5',
        userId: 'user1',
        name: 'Sistem Booking Salon',
        description: 'Aplikasi pemesanan layanan salon dan spa',
        icon: '💇',
        createdAt: '2024-01-14T11:00:00Z',
        updatedAt: '2024-01-14T11:00:00Z',
        status: 'DRAFT',
        pages: [
            {
                id: 'p12',
                applicationId: '5',
                tenantId: '5',
                name: 'Layanan',
                slug: 'services',
                components: [],
                order: 0,
                isHomePage: true,
                createdAt: '2024-01-14T11:00:00Z',
                updatedAt: '2024-01-14T11:00:00Z',
            },
        ],
        settings: {
            primaryColor: '#818cf8',
            theme: 'light',
            language: 'id',
        },
    },
    {
        id: '6',
        userId: 'user1',
        name: 'Aplikasi Inventory Gudang',
        description: 'Sistem manajemen stok dan inventory untuk gudang',
        icon: '📦',
        createdAt: '2024-01-11T13:00:00Z',
        updatedAt: '2024-01-15T10:30:00Z',
        status: 'PUBLISHED',
        pages: [
            {
                id: 'p13',
                applicationId: '6',
                tenantId: '6',
                name: 'Dashboard',
                slug: 'dashboard',
                components: [],
                order: 0,
                isHomePage: true,
                createdAt: '2024-01-11T13:00:00Z',
                updatedAt: '2024-01-11T13:00:00Z',
            },
            {
                id: 'p14',
                applicationId: '6',
                tenantId: '6',
                name: 'Stok Barang',
                slug: 'inventory',
                components: [],
                order: 1,
                isHomePage: false,
                createdAt: '2024-01-11T13:05:00Z',
                updatedAt: '2024-01-11T13:05:00Z',
            },
        ],
        settings: {
            primaryColor: '#6366f1',
            theme: 'light',
            language: 'id',
        },
    },
];
